/**
 * Decodes a URL-encoded search term. `+` is treated as a space before decoding, so a genuine
 * plus (`%2B`) survives, and a term holding a percent sequence `decodeURIComponent` rejects is
 * returned as-is rather than throwing.
 *
 * The result is trimmed, so a term that decodes to whitespace alone (`+`, `%20`) comes back empty
 * and reads as "no search term" to callers rather than anchoring a request on a blank string.
 *
 * @param {string} keyword - Possibly URL-encoded search term.
 * @returns {string} The decoded, trimmed search term.
 */
export const decodeKeyword = (keyword) => {
  try {
    return decodeURIComponent(keyword.replace(/\+/g, ' ')).trim();
  } catch {
    return keyword.trim();
  }
};
